import { all } from 'redux-saga/effects';
import { watchAuth } from './authSaga';
import { watchAssessment } from './assessmentSaga';
import { watchUser } from './userSaga';
import { watchPrompt } from './promptSaga';
import { watchLeader } from './leaderSaga';
import { watchLeaderInsight } from './leaderInsightSaga';

export default function* rootSaga() {
    yield all([
        watchAuth(),
        watchAssessment(),
        watchUser(),
        watchPrompt(),
        watchLeader(),
        watchLeaderInsight(),
    ]);
}